import React from "react";

const ScrollContext = React.createContext({});

export default ScrollContext;
